<template>
<div>
  <b-row>
    <b-colxx xxs="12">
      <h1><i class="simple-icon-chart mr-2"></i>Statistiques</h1>
      <div class="separator mb-5"></div>
    </b-colxx>
  </b-row>

  <b-row>
    <b-colxx sm="12" lg="6" class="mb-4">
      <b-card class="dashboard-filled-line-chart" no-body>
        <template v-if="!loadingNewPatientsChart">
          <b-card-body>
            <div class="float-left float-none-xs">
              <div class="d-inline-block">
                <h5 class="d-inline">{{ 'Nouveaux Patients' }}</h5>
              </div>
            </div>
            <b-dropdown id="ddown5" :text="newPatientsDuration=='week'?'Cette semaine':newPatientsDuration=='month'?'Ce mois':'Choisir un option'" size="xs" variant="outline-primary" class="float-right float-none-xs mt-2">
                <b-dropdown-item :style="newPatientsDuration=='week'?{background:'rgba(49, 127, 254,0.3)'}:{}" @click="selectPatientsDuration('week')">{{ 'Cette semaine' }}</b-dropdown-item>
                <b-dropdown-item :style="newPatientsDuration=='month'?{background:'rgba(49, 127, 254,0.3)'}:{}" @click="selectPatientsDuration('month')">{{ 'Ce mois' }}</b-dropdown-item>
            </b-dropdown>
          </b-card-body>
          <div class="chart card-body pt-0">
            <area-shadow-chart :duration="newDuration" :data="newPatientsChart" :height="195"/>
          </div>
        </template>
        <template v-else>
          <div class="loading"></div>
        </template>
      </b-card>
    </b-colxx>
    <b-colxx sm="12" lg="6" class="mb-4">
      <b-card class="dashboard-filled-line-chart" no-body>
        <template v-if="!loadingTraitedRdvChart">
          <b-card-body>
            <div class="float-left float-none-xs">
            <div class="d-inline-block">
              <h5 class="d-inline">{{ 'Rendez-Vous Traitées' }}</h5>
              <!-- <span class="text-muted text-small d-block">{{ $t('dashboards.per-session') }}</span> -->
            </div>
          </div>
            <b-dropdown id="ddown5" :text="rdvTraitedDuration=='week'?'Cette semaine':rdvTraitedDuration=='month'?'Ce mois':'Choisir un option'" size="xs" variant="outline-primary" class="float-right float-none-xs mt-2">
                <b-dropdown-item :style="rdvTraitedDuration=='week'?{background:'rgba(49, 127, 254,0.3)'}:{}" @click="selectRdvDuration('week')">{{ 'Cette semaine' }}</b-dropdown-item>
                <b-dropdown-item :style="rdvTraitedDuration=='month'?{background:'rgba(49, 127, 254,0.3)'}:{}" @click="selectRdvDuration('month')">{{ 'Ce mois' }}</b-dropdown-item>
            </b-dropdown>
          </b-card-body>
          <div class="chart card-body pt-0">
            <area-shadow-chart :duration="rdvDuration" :data="RdvTraitedChart" :height="195"/>
          </div>
        </template>
        <template v-else>
          <div class="loading"></div>
        </template>
      </b-card>
    </b-colxx>
    <b-colxx sm="12" lg="6" class="mb-4">
      <b-card class="h-100" :title="loadingTotalChart?'':'Resumé des rendez-vous'">
        <template v-if="!loadingTotalChart">
          <div class="dashboard-donut-chart">
            <doughnut-shadow-chart :state="changeTotalState" :data="totalRdvChart" :height="300"/>
          </div>
        </template>
        <template v-else>
          <div class="loading"></div>
        </template>
      </b-card>
    </b-colxx>
  </b-row>
  </div>
</template>
<script>
import AreaShadowChart from '@/components/Charts/AreaShadow'
import DoughnutShadowChart from '@/components/Charts/DoughnutShadow'
import { apiUrl } from "@/constants/config";

export default {
  components: {
    AreaShadowChart,
    DoughnutShadowChart
  },
  data () {
    return {
      loadingTotalChart:false,
      loadingNewPatientsChart:false,
      loadingTraitedRdvChart:false,
      changeTotalState:false,
      totalRdvChart: {
        labels: ['Confirmé', 'Non confirmé'],
        datasets: [
          {
            label: '',
            borderColor: ["#20c997","#6c757d"],
            backgroundColor: [
              "#20c997",
              "#6c757d"
            ],
            borderWidth: 2,
            data: []
          }
        ]
      },
      newPatientsDuration:"week",
      rdvTraitedDuration:"week",
      newPatientsChart:{
        labels: [],
        datasets: [
          {
            label: 'Nouveaux patients',
            data: [],
            borderColor: '#317ffe',
            pointBackgroundColor: '#317ffe',
            pointBorderColor: '#317ffe',
            pointHoverBackgroundColor: '#317ffe',
            pointHoverBorderColor: 'rgba(49, 127, 254,0.1)',
            pointRadius: 4,
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            fill: true
          }
        ]
      },
      RdvTraitedChart:{
        labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        datasets: [
          {
            label: 'Rendez-vous traitées',
            data: [9, 63, 60, 65, 60, 68, 60],
            borderColor: '#317ffe',
            pointBackgroundColor: '#317ffe',
            pointBorderColor: '#317ffe',
            pointHoverBackgroundColor: '#317ffe',
            pointHoverBorderColor: 'rgba(49, 127, 254,0.1)',
            pointRadius: 4,
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            fill: true
          }
        ]
      },
      newDuration:"",
      rdvDuration:""

    }
  },
  watch:{
    newPatientsDuration:{
      deep:true,
      handler(){
        this.fetchNewPatientsChartData()
      }
    },
    rdvTraitedDuration:{
      deep:true,
      handler(){
        this.fetchTraitedTdvsChartData()
      }
    }
  },
  mounted(){
    this.fetchNewPatientsChartData()
    this.fetchTraitedTdvsChartData()
    this.fetchRdvResume()
  },
  methods:{
    async fetchRdvResume(){
      this.loadingTotalChart = true
      let endpoint = apiUrl+'/stats/charts/rdvResume'
      let result = await this.sendRequest('post',endpoint)
      this.totalRdvChart.datasets[0].data = result.data
      this.changeTotalState = !this.changeTotalState
      this.loadingTotalChart = false
      this.$forceUpdate()
    },
    async fetchNewPatientsChartData(){
      this.loadingNewPatientsChart = true
      let endpoint = apiUrl+'/stats/charts/newPatients'
      let result = await this.sendRequest('post',endpoint,{duration:this.newPatientsDuration})
      // console.log("daaaata chart",result)
      this.newPatientsChart.labels = result.data.days
      this.newPatientsChart.datasets[0].data = result.data.stats
      this.newDuration = this.newPatientsDuration
      this.loadingNewPatientsChart = false
      this.$forceUpdate()
    },
    async fetchTraitedTdvsChartData(){
      this.loadingTraitedRdvChart = true
      let endpoint = apiUrl+'/stats/charts/traitedRdvs'
      let result = await this.sendRequest('post',endpoint,{duration:this.rdvTraitedDuration})
      // console.log("daaaata chart",result)
      this.RdvTraitedChart.labels = result.data.days
      this.RdvTraitedChart.datasets[0].data = result.data.stats
      this.rdvDuration = this.rdvTraitedDuration
      this.loadingTraitedRdvChart = false
      this.$forceUpdate()
    },
    selectPatientsDuration(duration){
      this.newPatientsDuration = duration

    },
    selectRdvDuration(duration){
      this.rdvTraitedDuration = duration
    }
  }
}
</script>
<style lang="scss" scoped>
.dropdown-menu{
  border-radius: 5px;
  padding: 0;
}
.loading{
  position: absolute;
}
</style>